import groq from 'groq'
import { imageAsset } from '../../imageAsset'
import { videoAsset } from '../../videoAsset'

export const features = groq`
 _type,
  featuresList,
  bottomNote,
  backgroundVideoDesktop {...${videoAsset()}},
  backgroundVideoMobile {...${videoAsset()}},
  mobilePatch {...${imageAsset()}},
`
